import DeletedPage from './DeletedPage';

export default DeletedPage;
